import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const updateIntegration = async (params) => {
  const user = getUserDetails();

  const queryString = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `&${k}=${encodeURIComponent(v)}`)
    .join("");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateTestSuiteIntegration&companyid=${user.companyid}${queryString}`,
  );

  return response.data;
};

const useUpdateIntegrationSettings = ({ onSuccess, onError } = {}) => {
  const mutation = useMutation({
    mutationFn: updateIntegration,
    onSuccess,
    onError,
  });

  return {
    ...mutation,
    mutate: mutation.mutate,
  };
};

export default useUpdateIntegrationSettings;
